import React, {Component} from 'react'

import {getDefaultMedia} from "../../../defaults/resourceLinker";
import GistPlayer from "../GistPlayer";

// STYLE ##########################################################

// COMPONENT ##########################################################

class IdentifierPlayer extends Component {
    state = {
        sourceInfo: null,
        sourceError: '',
    };

    componentDidMount() {
        this.loadDefaultSource();   // add call to seek default-source
    }

    loadDefaultSource() {
        getDefaultMedia(this.props.identifier).then(res => {
            if (res) { this.setState({sourceInfo: res}) }
            if (this.props.updateSourceType) {
                this.props.updateSourceType(GistPlayer.isVideo(res));
            }
            if (this.props.updateSource) {
                this.props.updateSource(res);
            }
        }).catch(error => {
            this.setState({sourceError: error.errorMsg})
        })
    }

    render() {
        const { sourceInfo, sourceError } = this.state;
        const uuid = (sourceInfo && sourceInfo.uuid) ? sourceInfo.uuid : '';

        return (
            <GistPlayer
                videoId={uuid}
                key={sourceInfo}
                dat={sourceInfo}
                errorMessage={sourceError}
            />
        );
    }
}

export default IdentifierPlayer;
